// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1EPuM","header":"ReportDetails_header__3ho2v","title":"ReportDetails_title__1-4BT","left":"ReportDetails_left__3iiZb"};